module.exports = __webpack_public_path__ + "img/linet-logo.b2f875ef.svg";